<template>
  <v-app bar :class="{ 'bg-yellowBack': $route.name === 'login' }">
    <Head>
      <Title>Soma</Title>
    </Head>
    <template v-if="appStore.movingVersions">
      <!-- Just display white screen, to give off an illusion of longer loading time, but actually we're disguising the redirect to other version, so it doesnt flicker -->
      <div></div>
    </template>
    <template v-else>
      <template v-if="userStore.authenticated">
        <template v-if="$vuetify.display.xs">
          <layout-main-app-bar />
          <layout-main-drawer />
          <layout-mobile-app-bar />
        </template>
        <template v-else>
          <layout-main-drawer />
          <layout-main-app-bar />
        </template>
        <layout-content-menu v-if="showContentMenu" />
        <layout-product-filter-menu v-else-if="productFiltersVisible" />
        <layout-pdf-content-menu v-else-if="showPdfContentMenu" />
      </template>
      <v-main :scrollable="$vuetify.display.xs">
        <layout-search-container v-if="userStore.authenticated" />
        <NuxtLayout>
          <nuxt-page />
        </NuxtLayout>
      </v-main>

      <LayoutSnackBar />

      <cookie-consent-banner />
    </template>
  </v-app>
</template>

<script>
import { contentMenuVisible, pdfContentMenuVisible, productFiltersVisible } from "~/helpers/index"
import { useAppStore } from "~/stores/appStore"
import { useUserStore } from "~/stores/userStore"
import { useCookieConsentUpdate } from "~/composables/useCookieConsentUpdate"

export default {
  setup() {
    window.userOnline = true
    const userStore = useUserStore()
    const appStore = useAppStore()
    userStore.init()
    useCookieConsentUpdate()
    setInterval((_) => userStore.reload({ successCallback: useCookieConsentUpdate }), 1000 * 60 * 15)
    return {
      appStore,
      userStore,
    }
  },

  computed: {
    showContentMenu() {
      return contentMenuVisible(this.$route)
    },

    productFiltersVisible() {
      return productFiltersVisible(this.$route)
    },

    showPdfContentMenu() {
      return pdfContentMenuVisible(this.$route)
    },
  },

  methods: {
    redirectToOldVersion() {
      const config = useRuntimeConfig()
      const path = window.location.pathname.slice(4)
      const completeOldUrl = config.public.oldFrontendRoot + path
      window.location.href = completeOldUrl
    },
  },
}
</script>

<style lang="sass">
@import "~/assets/css/vuetify/components.sass"
@import "~/assets/css/application.sass"
</style>
